import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M4.75 6.75V4C4.75 2.2 6.2.75 8 .75c1.75 0 3.2 1.4 3.25 3.2M7.95 19.25h-5.7c-.85 0-1.5-.65-1.5-1.5v-9.5c0-.85.65-1.5 1.5-1.5h2.5M8 6.75h5.75c.85 0 1.5.65 1.5 1.5v9.5c0 .85-.65 1.5-1.5 1.5h-2.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 14.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M8 13v3"
    }, null, -1)
  ]))]))
}
export default { render: render }